import { CommonModule } from '@angular/common';
import { input, computed, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { CircularProgressComponent } from '@/app/shared/components/ui/circular-progress';

import { booleanAttribute } from '@/app/shared/utils/coercion';
import { appInjectElement } from '@/app/shared/utils/inject-element';

export type ButtonSize = 'small' | 'medium' | 'large';

export type ButtonVariant = 'primary' | 'primary-outlined' | 'secondary-outlined';

export type ButtonType = 'submit' | 'button';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[app-button], a[app-button]',
  standalone: true,
  exportAs: 'app-button',
  imports: [CommonModule, CircularProgressComponent],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.type]': 'type()',
    '[attr.disabled]': 'disabledAttribute()',
    '[class]': 'buttonClasses()',
    '[class.app-button_loading]': 'loading()',
    '[class.app-button_disabled]': '!!disabledAttribute()',
  },
})
export class ButtonComponent {
  public element = appInjectElement<HTMLButtonElement>();

  size = input<ButtonSize>('medium');
  loading = input(false, { transform: booleanAttribute });
  variant = input<ButtonVariant>('primary');
  disabled = input(false, { transform: booleanAttribute });
  type = input<ButtonType>('button');

  disabledAttribute = computed(() => (!this.loading() && !this.disabled() ? null : true));
  buttonClasses = computed(() => `app-button app-button_${this.size()} app-button_${this.variant()}`);
}
